/**
 * Created by ah on 18/01/17.
 */

export const defaultAsyncActionFactory = (ACTION_BASE, property, apiCall, meta) => () => {
    const REQUEST = ACTION_BASE + '_REQUEST';
    const SUCCESS = ACTION_BASE + '_SUCCESS';
    const FAILURE = ACTION_BASE + '_FAILURE';

    return (dispatch) => {
        dispatch({type: REQUEST});
        return apiCall().then(result => {
            console.log("Success:", result)

            return dispatch({
                type: SUCCESS,
                payload: {[property]: result.data},
                meta: meta

            });
        }).catch(error => {
                const failAction = {type: FAILURE, error: true, meta: meta, payload: error.message};
                console.error("Error in default-async ", error)
                dispatch(failAction);
                return Promise.reject(error);
            })
    }
};




// WEBPACK FOOTER //
// ./src/model/action-creators/action-utils.js